import { ACCIONES } from '../utils/constantes';
import { api } from '../utils/funciones';

export default {
  methods: {
    apiBuilder(
      accion,
      fnServicio,
      datosPeticion,
      opciones,
      nombreRecurso,
      callbackPre = null,
      callbackPost = null,
      callbackOk = null,
      callbackError = null,
    ) {
      return api(
        accion,
        fnServicio,
        datosPeticion,
        opciones,
        callbackPre,
        callbackPost,
        (datos, mensaje) => {
          this.$notify({
            group: 'notifications',
            title: nombreRecurso,
            text: mensaje || 'Consulta exitosa',
            type: 'success',
          });

          if (callbackOk) {
            callbackOk(datos, mensaje);
          }
        },
        (errores, mensaje) => {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje,
            type: 'error',
          });

          if (callbackError) {
            callbackError(errores, mensaje);
          }
        },
      )();
    },
    findAllMixin(
      fnServicio,
      opciones,
      nombreRecurso,
      callbackPre = null,
      callbackPost = null,
      callbackOk = null,
      callbackError = null,
    ) {
      return this.apiBuilder(
        ACCIONES.LISTAR_TODOS,
        fnServicio,
        null,
        opciones,
        nombreRecurso,
        callbackPre,
        callbackPost,
        callbackOk,
        callbackError,
      );
    },
    findOneMixin(
      fnServicio,
      datosPeticion = { id: null },
      opciones,
      nombreRecurso,
      callbackPre = null,
      callbackPost = null,
      callbackOk = null,
      callbackError = null,
    ) {
      return this.apiBuilder(
        ACCIONES.LISTAR_POR_ID,
        fnServicio,
        datosPeticion,
        opciones,
        nombreRecurso,
        callbackPre,
        callbackPost,
        callbackOk,
        callbackError,
      );
    },
    async saveMixin(
      accion,
      fnServicio,
      datosPeticion,
      opciones,
      nombreRecurso,
      callbackPre = null,
      callbackPost = null,
      callbackOk = null,
      callbackError = null,
    ) {
      return this.apiBuilder(
        accion,
        fnServicio,
        datosPeticion,
        opciones,
        nombreRecurso,
        callbackPre,
        callbackPost,
        callbackOk,
        callbackError,
      );
    },
    async removeMixin(
      fnServicio,
      datosPeticion = { id: null },
      opciones,
      nombreRecurso,
      callbackPre = null,
      callbackPost = null,
      callbackOk = null,
      callbackError = null,
    ) {
      return this.apiBuilder(
        ACCIONES.ELIMINAR,
        fnServicio,
        datosPeticion,
        opciones,
        nombreRecurso,
        callbackPre,
        callbackPost,
        callbackOk,
        callbackError,
      );
    },
  },
};
